import { createApp, configureCompat } from 'vue'
import VueAsyncComputed from 'vue-async-computed'

import App from '@/App.vue'
import router from '@/router'

import AppPaymentCard from '@/components/App/PaymentCard.vue'
import AppNewPaymentCard from '@/components/App/NewPaymentCard.vue'
import AppFullWrapper from '@/components/App/FullWrapper.vue'
import AppDropdown from '@/components/App/Dropdown.vue'
import AppDropdownMenu from '@/components/App/Dropdown/Menu.vue'
import AppDropdownMenuItem from '@/components/App/Dropdown/Menu/Item.vue'
import AppTags from '@/components/App/Tags.vue'
import AppTag from '@/components/App/Tags/Tag.vue'
import AppRadio from '@/components/App/Radio.vue'
import AppMessage from '@/components/App/Message.vue'
import AppWrapper from '@/components/App/Wrapper.vue'
import AppInfiniteScroll from '@/components/App/InfiniteScroll.vue'
import AppRatingStars from '@/components/App/RatingStars.vue'
import AppLayout from '@/components/App/Layout.vue'
import AppLayoutHeader from '@/components/App/Layout/Header.vue'
import AppLayoutContent from '@/components/App/Layout/Content.vue'
import AppLayoutFooter from '@/components/App/Layout/Footer.vue'
import AppButtonsContainer from '@/components/App/Buttons/Container.vue'
import AppPlaceholder from '@/components/App/Placeholder.vue'
import AppButtons from '@/components/App/Buttons.vue'
import AppButton from '@/components/App/Buttons/Button.vue'
import AppSection from '@/components/App/Section.vue'
import AppSectionContent from '@/components/App/Section/Content.vue'
import AppSubheader from '@/components/App/Subheader.vue'
import AppCheckbox from '@/components/App/Checkbox.vue'
import AppHorizontalList from '@/components/App/HorizontalList.vue'
import AppList from '@/components/App/List.vue'
import AppListItem from '@/components/App/List/Item.vue'
import AppListItemDivider from '@/components/App/List/Item/Divider.vue'
import AppListItemContent from '@/components/App/List/Item/Content.vue'
import AppListItemImage from '@/components/App/List/Item/Image.vue'
import AppSwitch from '@/components/App/Switch.vue'
import AppForm from '@/components/App/Form.vue'
import AppModal from '@/components/App/Modal.vue'
import AppModalHeader from '@/components/App/Modal/Header.vue'
import AppModalContent from '@/components/App/Modal/Content.vue'
import AppModalFooter from '@/components/App/Modal/Footer.vue'
import AppSnackbars from '@/components/App/Snackbars.vue'
import AppSnackbar from '@/components/App/Snackbars/Snackbar.vue'
import AppCollapse from '@/components/App/Collapse.vue'
import AppCards from '@/components/App/Cards.vue'
import AppCard from '@/components/App/Card.vue'
import AppCardButtons from '@/components/App/Card/Buttons.vue'
import AppCardButton from '@/components/App/Card/Button.vue'
import AppNavbar from '@/components/App/Navbar.vue'
import AppNavbarItem from '@/components/App/Navbar/Item.vue'
import AppSelect from '@/components/App/Select.vue'
import AppSelectItem from '@/components/App/Select/Item.vue'
import AppInput from '@/components/App/Input.vue'
import AppInputGroup from '@/components/App/InputGroup.vue'
import AppInputHelpText from '@/components/App/Input/HelpText.vue'
import AppInputContainer from '@/components/App/Input/Container.vue'
import AppImage from '@/components/App/Image.vue'
import AppSmallText from '@/components/App/SmallText.vue'
import AppTimeAgo from '@/components/App/TimeAgo.vue'
import AppPrices from '@/components/App/Prices.vue'
import AppPrice from '@/components/App/Price.vue'
import AppToolbar from '@/components/App/Toolbar.vue'
import AppToolbarContent from '@/components/App/Toolbar/Content.vue'
import AppSidebar from '@/components/App/Sidebar.vue'
import AppIcon from '@/components/App/Icon.vue'
import AppLegend from '@/components/App/Legend.vue'
import AppLegendDescription from '@/components/App/Legend/Description.vue'
import AppHeader from '@/components/App/Header.vue'

import GlobalMixin from '@/components/Mixins/Global.vue'

configureCompat({
  WATCH_ARRAY: false,
  ATTR_FALSE_VALUE: false,
  COMPONENT_ASYNC: false,
  COMPONENT_V_MODEL: false,
  ATTR_ENUMERATED_COERCION: false,
})

const app = createApp(App)

app.mixin(GlobalMixin)

app.component('app-header', AppHeader)
app.component('app-payment-card', AppPaymentCard)
app.component('app-new-payment-card', AppNewPaymentCard)
app.component('app-full-wrapper', AppFullWrapper)
app.component('app-dropdown', AppDropdown)
app.component('app-dropdown-menu', AppDropdownMenu)
app.component('app-dropdown-menu-item', AppDropdownMenuItem)
app.component('app-tags', AppTags)
app.component('app-tag', AppTag)
app.component('app-radio', AppRadio)
app.component('app-icon', AppIcon)
app.component('app-legend', AppLegend)
app.component('app-legend-description', AppLegendDescription)
app.component('app-wrapper', AppWrapper)
app.component('app-message', AppMessage)
app.component('app-infinite-scroll', AppInfiniteScroll)
app.component('app-rating-stars', AppRatingStars)
app.component('app-layout', AppLayout)
app.component('app-layout-header', AppLayoutHeader)
app.component('app-layout-content', AppLayoutContent)
app.component('app-layout-footer', AppLayoutFooter)
app.component('app-buttons-container', AppButtonsContainer)
app.component('app-placeholder', AppPlaceholder)
app.component('app-buttons', AppButtons)
app.component('app-button', AppButton)
app.component('app-section', AppSection)
app.component('app-section-content', AppSectionContent)
app.component('app-subheader', AppSubheader)
app.component('app-switch', AppSwitch)
app.component('app-checkbox', AppCheckbox)
app.component('app-horizontal-list', AppHorizontalList)
app.component('app-list', AppList)
app.component('app-list-item', AppListItem)
app.component('app-list-item-content', AppListItemContent)
app.component('app-list-item-image', AppListItemImage)
app.component('app-list-item-divider', AppListItemDivider)
app.component('app-form', AppForm)
app.component('app-modal', AppModal)
app.component('app-modal-header', AppModalHeader)
app.component('app-modal-content', AppModalContent)
app.component('app-modal-footer', AppModalFooter)
app.component('app-snackbars', AppSnackbars)
app.component('app-snackbar', AppSnackbar)
app.component('app-collapse', AppCollapse)
app.component('app-cards', AppCards)
app.component('app-card', AppCard)
app.component('app-card-buttons', AppCardButtons)
app.component('app-card-button', AppCardButton)
app.component('app-navbar', AppNavbar)
app.component('app-navbar-item', AppNavbarItem)
app.component('app-select', AppSelect)
app.component('app-select-item', AppSelectItem)
app.component('app-input', AppInput)
app.component('app-input-group', AppInputGroup)
app.component('app-input-container', AppInputContainer)
app.component('app-input-help-text', AppInputHelpText)
app.component('app-time-ago', AppTimeAgo)
app.component('app-prices', AppPrices)
app.component('app-price', AppPrice)
app.component('app-image', AppImage)
app.component('app-sidebar', AppSidebar)
app.component('app-toolbar', AppToolbar)
app.component('app-toolbar-content', AppToolbarContent)
app.component('app-small-text', AppSmallText)

// configureCompat({
//   COMPONENT_ASYNC: false,
//   COMPONENT_V_MODEL: false,
//   ATTR_ENUMERATED_COERCION: false,
// })

app.use(router)
app.use(VueAsyncComputed)

router.isReady().then(() => {
  app.mount('#app')
})

export { app }
